<form [formGroup]="form" *ngIf="config && form">
  <div class="form-group">
    <label class="bmd-label-floating" for="invoiceTypeId">Invoice Type ID</label>
    <input type="text" class="form-control" formControlName="invoiceTypeId" name="invoiceTypeId" />
  </div>
  <div class="form-group">
    <label class="bmd-label-floating" for="billerGuid">Biller GUID</label>
    <input type="text" class="form-control" formControlName="billerGuid" name="billerGuid" />
  </div>
</form>